import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Auth.css";

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("typeace-theme") || "light";
  })
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (data.success) {
        if (rememberMe) {
          localStorage.setItem("typeace_token", data.token);
        } else {
          sessionStorage.setItem("typeace_token", data.token);
        }
        navigate("/dashboard");
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  //theme
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("typeace-theme", theme);
  }, [theme]);

  return (
    <div className="auth-container" data-theme="light">
      {/* Background Effects */}
      <div className="auth-grid-bg"></div>
      <div className="auth-noise-overlay"></div>
      <div className="auth-orb auth-orb-1"></div>
      <div className="auth-orb auth-orb-2"></div>
      <div className="auth-card-wrapper">
        {/* Brand Section */}
        <div className="auth-brand">
          <svg className="auth-brand-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
          </svg>
          <span onClick={() => (navigate('/'))} className="auth-brand-name">TypeAce</span>
        </div>
        {/* Auth Card */}
        <div className="auth-card">
          <h1 className="auth-title">Institution Login</h1>
          <p className="auth-subtitle">Access your admin dashboard</p>
          {error && (
            <div className="auth-message auth-message-error">
              <span>⚠️</span>
              {error}
            </div>
          )}
          <form onSubmit={handleLogin} className="auth-form">
            {/* Email Field */}
            <div className="input-field-container">
              <label className="input-label">
                Email <span className="input-required">*</span>
              </label>
              <div className="input-wrapper">
                <input
                  type="email"
                  placeholder="admin@institution.edu"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="input-element"
                />
              </div>
            </div>
            {/* Password Field */}
            <div className="input-field-container">
              <label className="input-label">
                Password <span className="input-required">*</span>
              </label>
              <div className="input-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="input-element"
                />
                <button
                  type="button"
                  className="input-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? "👁️" : "👁️‍🗨️"}
                </button>
              </div>
            </div>
            {/* Remember Me */}
            <label className="auth-checkbox">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              Remember me
            </label>
            {/* Submit Button */}
            <button
              type="submit"
              className="btn btn-primary btn-full-width"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="btn-spinner">⌛</span>
                  Logging in...
                </>
              ) : (
                "Login to Dashboard"
              )}
            </button>
          </form>
          {/* Footer Links */}
          <div className="auth-footer-links">
            <p className="auth-footer-text">
              Don't have an institution account?
              <a href="/signup" className="auth-link">
                Register
              </a>
            </p>
            <p className="auth-footer-text" style={{ marginTop: '8px' }}>
              <a href="/forgot-password" className="auth-link">
                Forgot password?
              </a>
            </p>
          </div>
          <div className="auth-footer">
            <p>© 2024 TypeAce. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};